export const NavigationState = 'navigation-state';
export const ZOOM_BEHAVIOR_WIDTH: number = 900;
export const MAX_MOBILE_WIDTH: number = 576;
export const MAX_TABLET_WIDTH: number = 767;
